import _ from 'lodash';
/**
 * Decodes an HTML string. See https://lodash.com/docs#unescape
 */
export default _.unescape;
//# sourceMappingURL=decodeHtml.js.map